import type { Logger } from './types'
import { AppLogger } from './AppLogger'
import { LogRocketProvider } from './providers/logrocket'

export type { Logger, LoggerUser, LoggerErrorContext } from './types'
export type { LoggerProvider } from './providers/types'

export const logger: Logger = new AppLogger([new LogRocketProvider()])
